import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { labelSingularLower } from "@/utils/copyTituloBilhete"

export interface DialogNavegarPosPagamentoPixAppProps {
    exibir: boolean,
    toggleDialog: () => void
}

export function DialogNavegarPosPagamentoPixApp({ exibir, toggleDialog }: DialogNavegarPosPagamentoPixAppProps) {
    return (
        <AlertDialog open={exibir}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle className="text-2xl text-primary-foreground">
                        Você já realizou o pagamento?
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        {`Feche o navegador e acesse o histórico de compras em seu aplicativo para visualizar seu ${labelSingularLower()}.`}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <Button variant='destructive' onClick={toggleDialog}>Fechar</Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}